import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-accent-400">久久爱</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              久久爱是专为渴望长久爱情的人打造的情感陪伴平台。无论你正在寻找真爱、维系感情还是修复关系，久久爱都能为你提供专业情感指导、伴侣匹配与深度陪伴服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/categories" className="text-sm text-background-300 hover:text-background-50 transition-colors">分类浏览</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">服务分类</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/categories?tab=emotional-guidance" className="text-sm text-background-300 hover:text-background-50 transition-colors">情感指导</Link>
              </li>
              <li>
                <Link to="/categories?tab=partner-matching" className="text-sm text-background-300 hover:text-background-50 transition-colors">伴侣匹配</Link>
              </li>
              <li>
                <Link to="/categories?tab=relationship-repair" className="text-sm text-background-300 hover:text-background-50 transition-colors">感情修复</Link>
              </li>
              <li>
                <Link to="/categories?tab=long-term-companion" className="text-sm text-background-300 hover:text-background-50 transition-colors">长久陪伴</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {currentYear} 久久爱 版权所有 | 让每一段爱都值得被珍惜
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-background-50 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-50 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-50 transition-colors" aria-label="小红书">
              <i className="ri-article-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}